<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>

    <loading
        :active.sync="loader"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>

    <b-card class="bCardAgenda">
      <b-container fluid="">
        <b-row class="divSubtitulo m-1 mb-3">
          <b-col cols="6" md="8">
            <div>
              <p class="textoSubtitulo">Paciente Ortopantomógrafo</p>
            </div>
          </b-col>
          <b-col cols="6" md="4">
            <div>
              <p style="text-align:right" class="textoSubtitulo">CÓDIGO: </p>
            </div>
          </b-col>
        </b-row>
      </b-container>

      <div class="mt-2"></div>

      <b-container fluid="">
        <b-row class="text-center mt-4">
          <b-col cols="9"></b-col>
          <b-col cols="3" class="text-left mt-auto mb-auto text-right">
            <b-button
                v-if="$localStorageService.can('Carga_Archivo_orto')"
                variant="outline-info"
                title="Cargar Archivo"
                class=""
                @click="agregar"
                responsive
            >
              Cargar Archivo
            </b-button>
          </b-col>

          <b-col cols="12">
            <b-row>
              <b-col sm="12" md="12" lg="12" class="contenedorTablaSinColor mt-5">
                <b-table
                    id="Pendientes"
                    thead-tr-class="columnasTablaSinColor"
                    :items="datosTabla"
                    :fields="fields"
                    :per-page="registrosPorPagina"
                    :current-page="paginaActual"
                    responsive="true"
                    fixed
                >
                  <template v-slot:cell(fechaAlta)="row">
                    {{ row.item.fechaAlta | formatoFecha1}}
                  </template>

                  <template v-slot:cell(Acciones)="row" style="width: 200px">
                    <b-button
                        v-if="$localStorageService.can('Descarga_Archivo_orto')"
                        title="Descargar"
                        size="sm"
                        variant="outline-primary"
                        @click="descargarAchivo(row.item)">
                      <em
                          class="fa fa-download">
                      </em>
                    </b-button>
                  </template>
                </b-table>


                <div align="center" v-if="loader">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                </div>
                <b-col v-else>
                  <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
                </b-col>
              </b-col>
              <b-col v-if="!loader">
                <b-pagination
                    v-if="datosTabla !== undefined && datosTabla.length > 10"
                    align="center"
                    v-model="paginaActual"
                    :total-rows="datosTabla.length"
                    :per-page="registrosPorPagina"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-col>

        </b-row>
      </b-container>
    </b-card>


    <b-modal
        no-enforce-focus
        no-close-on-backdrop
        no-close-on-esc
        v-model="showModal"
        size="lg"
        class="redondeo"
        centered>
      <b-form @submit.stop.prevent="guardar">
        <b-row>
          <b-col>
            <b-form-group align="left">
              <label for="descripcion">Clínica
              </label>
              <validacion/>
              <b-input-group size="sm" class="mb-2">
                <v-select
                    style="width: 100%"
                    v-model="$v.objGuardar.idClinica.$model"
                    :state="validateState('idClinica')"
                    :options="clinicas"
                    :reduce="variable => variable.id_clinica"
                    label="nombre"
                >
                  <template slot="no-options">Sin datos</template>
                </v-select>
              </b-input-group>
            </b-form-group>

            <b-form-group>
              <label for="descripcion">Paciente
              </label>
              <validacion/>
              <b-input-group>
                <b-form-checkbox v-model="buscarPorId" >Buscar paciente por ID</b-form-checkbox>
              </b-input-group>
              <b-input-group>
                <b-form-input placeholder="Paciente (minimo 10 caracteres y 2 palabras)" v-model="nombre"/>
                <b-input-group-append>
                  <b-button v-on:click="traerPacientesPorNombreLike">
                    <b-spinner small variant="info" v-if="pacienteService.loading"/>
                    <font-awesome-icon v-else icon="search"/>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <v-select
                  v-model="$v.objGuardar.idPaciente.$model"
                  :state="validateState('idPaciente')"
                  :options="pacienteService.data"
                  :reduce="variable => variable.idPaciente"
                  label="nombreCompleto"
              ></v-select>
            </b-form-group>

            <b-form-group align="left">
              <label for="descripcion">Carga de archivo
              </label>
              <validacion/>
              <b-input-group size="sm" class="mb-2">
                <b-form-file
                    accept=".zip"
                    ref="archivo"
                    @change="base64($event)"
                    :state="validateState('archivoBase64')"
                    placeholder="Selecciona o arrastra un archivo"
                    drop-placeholder="Suelta el archivo aquí..."
                ></b-form-file>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-button ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>
      </b-form>


      <template #modal-header="{ ok, close }">
        <div class="seccionTitle mLeft h5">
          <em class=" nuevo_cupon_svg" style=" height: 40px"></em>
          <div class="headerTxt mLeft">{{ tituloModal }}</div>
        </div>
      </template>

      <template #modal-footer="{ ok, cancel }">
        <div class="w-100 float-none text-center">
          <b-button class="mt-3 botonesAzulFuerte"
                    variant="primary"
                    :disabled="loaderAcciones"
                    @click="$refs.submitGuardar.click()"
          >
            Guardar
          </b-button>
          <b-button
              class="mt-3 botonesGrisFuerte"
              :disabled="loaderAcciones"
              @click="cerrarModal()"
          >
            Cancelar
          </b-button>
        </div>
      </template>

    </b-modal>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import {required} from "vuelidate/lib/validators";
import {PacienteService} from "@/apiServices/paciente/PacienteService";

export default {
  name: "PacienteOrtopantomografo",
  components: {Header},
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      loader: false,
      loaderAcciones: false,
      tituloModal: '',
      showModal: false,
      buscarPorId: false,
      nombre: '',
      datosTabla: [],
      clinicas: [],
      fields: [
        {key: "idPacienteOrtopantomografo", label: "ID", sortable: true},
        {key: "nombrePaciente", label: "Paciente", sortable: true},
        {key: "nombreclinica", label: "Clínica", sortable: true},
        {key: "fechaAlta", label: "Fecha Alta", sortable: true},
        "Acciones",
      ],
      registrosPorPagina: 10,
      paginaActual: 1,
      objGuardar: {
        idPaciente: null,
        idClinica: null,
        archivoBase64: null
      },
      pacienteService: new PacienteService(),
    }
  },
  validations: {
    objGuardar: {
      idPaciente: {required},
      idClinica: {required},
      archivoBase64: {required}
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerOrtopantomografo();
    this.obtenerClinicasActivas();
  },
  methods: {
    obtenerOrtopantomografo() {
      this.loader = true;
      this.$http
          .get(this.$api + 'pacienteV5/obtener/ortopantomografo')
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.datosTabla = respuesta.data.data;
            }
          })
          .finally(() => {
            this.loader = false;
          });
    },
    guardar() {
      this.$v.objGuardar.$touch();
      if (this.$v.objGuardar.$anyError) {
        return;
      }
      this.loader = true
      this.loaderAcciones = true;

      const formData = new FormData();
      formData.append("archivoBase64", this.objGuardar.archivoBase64);
      formData.append("idPaciente", this.objGuardar.idPaciente);
      formData.append("idClinica", this.objGuardar.idClinica);

      this.$http.post(this.$api + 'pacienteV5/guardar/ortopantomografo', formData, {headers: {'Content-Type': 'multipart/form-data',},}).then(respuesta => {
            if (respuesta.data.data) {
              this.showModal = false;
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "El archivo se guardó correctamente"
              });
              this.obtenerOrtopantomografo();
              this.limpiar();
            }
          }
      ).catch(error => {
        console.error(error.message)
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: error.message,
        });
      }).finally(() => {
        this.loaderAcciones = false;
        this.loader = false;
      })
    },
    descargarAchivo(archivo) {
      this.loader = true
      const params = {
        idPacienteOrtopantomografo: archivo.idPacienteOrtopantomografo
      }
      this.$http.post(this.$api + 'pacienteV5/descargar/ortopantomografo', params)
          .then((response) => {
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = response.data.data;
            a.download = archivo.nombrePaciente + '_' + archivo.nombreclinica + '.zip';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(response.data.data);
          })
          .catch((error) => {
            console.error(error);
            this.$swal.fire({
              icon: "error",
              title: "Ocurrio un error",
              text: error.response.data.message,
            });
          }).finally(() => {
        this.loader = false
      });
    },

    traerPacientesPorNombreLike() {
      this.pacienteService.data = [];
      if (this.buscarPorId === false && this.nombre.length > 9 && this.nombre.split(' ').length >= 2) {
        this.pacienteService.obtenerPacientesPorNombreLike(this.nombre.toUpperCase());
      }else if (this.buscarPorId === true){
        this.pacienteService.obtenerPacientesPorId(this.nombre.toUpperCase());
      }
    },
    base64(e){
      let base = e.target.files || e.dataTransfer.files;
      this.objGuardar.archivoBase64 = base[0];
    },
    obtenerClinicasActivas() {
      this.$http
          .get(this.$api + "catalogos/obtenerClinicas")
          .then((response) => {
            this.clinicas = response.data.data;
          })
          .catch((error) => {
            console.error(error);
          })
    },

    agregar() {
      this.tituloModal = 'Cargar Archivo';
      this.showModal = true;
    },
    cerrarModal() {
      this.showModal = false;
      this.limpiar()
    },
    limpiar() {
      this.$nextTick(() => {
        this.$v.$reset()
      });
      this.objGuardar = {
        idPaciente: null,
        idClinica: null,
        archivoBase64: null
      }
      this.$refs.archivo.reset();
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.objGuardar[name];
      return $dirty ? !$error : null;
    },
  }
}
</script>


<style scoped>

</style>